/** Langues pour la génération IA (aligné backend). */
export const HUBUP_NOTIFICATION_AI_LANGUAGES = [
  { code: 'fr', label: 'Français', flagCountry: 'fr' },
  { code: 'en', label: 'English', flagCountry: 'gb' },
  { code: 'de', label: 'Deutsch', flagCountry: 'de' },
  { code: 'es', label: 'Español', flagCountry: 'es' },
  { code: 'it', label: 'Italiano', flagCountry: 'it' },
  { code: 'pt', label: 'Português', flagCountry: 'pt' },
  { code: 'nl', label: 'Nederlands', flagCountry: 'nl' },
  { code: 'pl', label: 'Polski', flagCountry: 'pl' },
  { code: 'ar', label: 'العربية', flagCountry: 'sa' },
  { code: 'zh', label: '中文', flagCountry: 'cn' },
  { code: 'ja', label: '日本語', flagCountry: 'jp' },
  { code: 'ko', label: '한국어', flagCountry: 'kr' },
  { code: 'ru', label: 'Русский', flagCountry: 'ru' },
  { code: 'tr', label: 'Türkçe', flagCountry: 'tr' },
  { code: 'hi', label: 'हिन्दी', flagCountry: 'in' },
  { code: 'sv', label: 'Svenska', flagCountry: 'se' },
  { code: 'da', label: 'Dansk', flagCountry: 'dk' },
  { code: 'nb', label: 'Norsk', flagCountry: 'no' },
  { code: 'fi', label: 'Suomi', flagCountry: 'fi' },
  { code: 'cs', label: 'Čeština', flagCountry: 'cz' },
  { code: 'ro', label: 'Română', flagCountry: 'ro' },
  { code: 'hu', label: 'Magyar', flagCountry: 'hu' },
  { code: 'el', label: 'Ελληνικά', flagCountry: 'gr' },
  { code: 'he', label: 'עברית', flagCountry: 'il' },
  { code: 'uk', label: 'Українська', flagCountry: 'ua' },
  { code: 'vi', label: 'Tiếng Việt', flagCountry: 'vn' },
  { code: 'th', label: 'ไทย', flagCountry: 'th' },
  { code: 'id', label: 'Bahasa Indonesia', flagCountry: 'id' },
  { code: 'ms', label: 'Bahasa Melayu', flagCountry: 'my' },
  { code: 'ca', label: 'Català', flagCountry: 'es-ct' },
];

export const DEFAULT_NOTIFICATION_AI_LANGUAGE = 'fr';

/** URL drapeau (PNG) — fiable sur Windows où les emoji drapeaux affichent « FR », « DE », etc. */
export function notificationAiFlagUrl(flagCountry) {
  const c = String(flagCountry || '').trim().toLowerCase();
  if (!c) return null;
  return `https://flagcdn.com/w40/${c}.png`;
}

export function findNotificationAiLanguage(code) {
  return HUBUP_NOTIFICATION_AI_LANGUAGES.find((l) => l.code === code);
}
